import { api } from './api';

export const defaultSketchImagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultSketchImagesAdmin: builder.query({
      query: (params = {}) => {
        const queryParams = {};
        if (params.type != null && String(params.type).trim() !== '') {
          queryParams.type = String(params.type).trim();
        }
        if (params.status != null && params.status !== '') {
          queryParams.status = Number(params.status);
        }
        return {
          url: '/admin/default-sketch-images',
          params: queryParams,
        };
      },
      providesTags: ['DefaultSketchImage'],
    }),
    uploadDefaultSketchImage: builder.mutation({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/admin/default-sketch-images/upload',
          method: 'POST',
          body: formData,
        };
      },
    }),
    createDefaultSketchImage: builder.mutation({
      query: (body) => ({
        url: '/admin/default-sketch-images',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DefaultSketchImage'],
    }),
    updateDefaultSketchImage: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/default-sketch-images/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['DefaultSketchImage'],
    }),
  }),
});

export const {
  useGetDefaultSketchImagesAdminQuery,
  useUploadDefaultSketchImageMutation,
  useCreateDefaultSketchImageMutation,
  useUpdateDefaultSketchImageMutation,
} = defaultSketchImagesApi;
